// import axios from "axios";

export const CORSproxy = "https://cors-anywhere.herokuapp.com/"
// proxy + "http://docs.google.com/forms/d/e/1FAIpQLSceXYLXYAAUwu8RoLl61VcAJyCSG0MXASBNEWyx1mhBNVR3_Q/formResponse"
const localStorageName = [
    'courseGroups',
    'courseGroupsAvailable',
    'usingCourse',
    'timetableOptions',
    'user',
    'coursesDiscuss', 'coursesExtension']

export const syncStorageName = [
    'courseGroups',
    'courseGroupsAvailable',
    'usingCourse',
    'user',
    'coursesExtension']


export function saveSession(state) {
    for (let key of localStorageName) {
        localStorage.setItem(key, JSON.stringify(state[key]))
    }
    console.log('Session saved')
}

// export function uploadSession(state) {
//     // var uploadingSession = {}
//     // for (let key of syncStorageName) {
//     //     uploadingSession[key] = state[key]
//     // }
//     // let d = {
//     //     'entry.118437476': JSON.stringify(uploadingSession),
//     //     'entry.751211111': state.user.loginInfo.name
//     // }
//     // console.log(d)
//     // axios({method: 'get', url: inboxUrl, params: d}
//     // ).then(
//     //     () => console.log("Backup Succeed")
//     // )
//     //     .catch(
//     //         (e) => console.log("Backup failed", e)
//     //     )
//
// }

export function ezLoad(key) {
    let shouldReset = false
    let rawValue = localStorage.getItem(key)
    let objectValue = null
    try {
        objectValue = JSON.parse(rawValue)
    } catch (e) {
        objectValue = rawValue
    }
    if (shouldReset) {
        return null
    }
    return objectValue
}
